module.exports = __webpack_public_path__ + "static/media/Sleeping-Face.a3f59272.webp";